import React from 'react'

export const About = ({item}) => {

  return (
    <div className=' space-y-6'>
              <div>
        <h4 className="text-xl font-bold mb-2">
          A propos de l'entreprise
        </h4>
        <p className='text-primary-text'>
        {item?.organisation_profile?.description}
        </p>
      </div>

      <div>
        <h4 className="text-xl font-bold mb-2">
          Description
        </h4>
        <p className='text-primary-text'>
        {item?.organisation_profile?.description}
         </p>
      </div>

      <div>
        <h4 className="text-xl font-bold mb-2">
          Missions et Responsabilités
        </h4>
        <p className='text-primary-text'>
        {item?.organisation_profile?.objective}
         </p>
      </div>

      {/* <div>
        <h4 className="text-xl font-bold mb-2">
          Avantages
        </h4>
        <p className='text-primary-text'>
        {item?.organisation_profile?.benefits}
          </p>
      </div> */}
    </div>
  )
}
